function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Icon } from '@doordash/design-language';
import { IconContainer } from './components/styles';
import RawTextField from './components/RawTextField';
import React from 'react';
import omit from 'lodash.omit';

var SearchField = function SearchField(props) {
  return React.createElement(RawTextField, _extends({
    renderBeforeContent: function renderBeforeContent() {
      return React.createElement(IconContainer, null, React.createElement(Icon, {
        color: Icon.Colors.FieldsIconSearch,
        type: Icon.Types.Search,
        size: Icon.Sizes.Medium
      }));
    }
  }, props, {
    type: "search"
  }));
};

SearchField.Sizes = RawTextField.Sizes;
SearchField.propTypes = omit(RawTextField.propTypes, ['type', 'isMultiline']);
SearchField.defaultProps = RawTextField.defaultProps;
export default SearchField;